import { render, staticRenderFns } from "./NeedsSummaryPanel.vue?vue&type=template&id=5a0c363f&scoped=true&"
import script from "./NeedsSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./NeedsSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./NeedsSummaryPanel.vue?vue&type=style&index=0&id=5a0c363f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c363f",
  null
  
)

export default component.exports